import { useEffect, useState } from "react";
import { Caracteristicas } from "../../../interfaces/Caracteristicas";
import { CaracteristicasEmprendimento } from "../../../interfaces/CaracteristicasEmprendimento";
import { buscarCaracteristicasService } from "../../../services/buscarCaracteristicasService";

export const useBuscarCaracteristicas = (
  isModalOpen: boolean,
  empreendId: number
) => {
  const [caracteristicas, setCaracteristicas] = useState<Caracteristicas[]>([]);
  const [caracteristicasEmpreend, setCaracteristicasEmpreend] = useState<
    CaracteristicasEmprendimento[]
  >([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const buscar = async () => {
      setIsLoading(true);
      const data = await buscarCaracteristicasService(
        "EMPREENDIMENTO",
        empreendId
      );
      setCaracteristicas(data.caracteristicas || []);
      setCaracteristicasEmpreend(
        (data.vinculadas as CaracteristicasEmprendimento[]) || []
      );
      setIsLoading(false);
    };

    if (isModalOpen && empreendId) {
      buscar();
    } else {
      setCaracteristicas([]);
      setCaracteristicasEmpreend([]);
      setIsLoading(false);
    }
  }, [isModalOpen, empreendId]);

  return { caracteristicas, caracteristicasEmpreend, isLoading };
};
